import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    switchesContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    scrollContent: {
        justifyContent: "center",
        alignItems: "center"
    },
    previewContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    descText: {
        marginBottom: 20
    },
    contentContainer: {
        width: "100%",
        padding: 20
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
